import React from 'react';
import AuditDashboard from 'Components/AuditDashboard/index';

const AuditDashboardPage = () => {
  return <AuditDashboard />;
};

export default AuditDashboardPage;